import {Alert, Button} from "antd";
import {CustomerBreadcrumb} from "../../../../components/customers/customer-breadcrumb/customer-breadcrumb";
import {InfoSection} from "../../../../components/customers/details-page/info-section";
import {PrevPurchasesSection} from "../../../../components/customers/details-page/prev-purchases-section/prev-purchases-section";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledCustomersPageWrapper} from "../../../../styles/customers/customers";
import {ErrorBoundary} from "react-error-boundary";

const ViewCustomerDetailsPage = () => {
  return (
    <DashboardWrapper pageTitle="Customer Details">
      <CustomerBreadcrumb />
      <StyledCustomersPageWrapper>
        <>
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <InfoSection />
            <PrevPurchasesSection />
          </ErrorBoundary>
        </>
      </StyledCustomersPageWrapper>
    </DashboardWrapper>
  );
};

export {ViewCustomerDetailsPage};
